module.exports = __webpack_public_path__ + "media/components/country-flag/static/iq-c4c7bb4a89ff8561aa02bcf7bd11b378.svg";